import React from 'react';
import Glob from "../../../libs/Glob.mjs";
import {Button, ButtonGroup, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import CloseIcon from "../../../media/images/CloseIcon.mjs";
import "./UserInfoModal.css";
import EditIcon from "../../../media/images/EditIcon.mjs";
import AppSettingIcon from "../../../media/app-images/AppSettingIcon.mjs";
import PropTypes from "prop-types";

const prefix = 'UserInfoModal';

const UserInfoModal = class extends React.Component {
	static propTypes = {
		user: PropTypes.object.isRequired,
		edit: PropTypes.func,
		close: PropTypes.func.isRequired
	}
	constructor(props) {
		super(props);
		this.state = { ll: Glob.getLanguageLong() };
		this.uid = Glob.generateUid(prefix);
		this.close = this.close.bind(this);
	}
	close() {
		this.props.close();
	}
	render() {
		const u = this.props.user ?? {}
		return(
			<Modal
				id={this.uid}
				className={prefix}
				isOpen={true}
				fade={false}
				toggle={this.close}
			>
				<ModalHeader toggle={this.close}>
					<AppSettingIcon />
					{ u.username }
				</ModalHeader>
				<ModalBody>
					<table>
						<tbody>
						<tr>
							<td>
								<TextLabel value={"LastSeen"} />
							</td>
							<td>
								{ u.lastSeen ? new Date(u.lastSeen).toLocaleString(this.state.ll) : <TextLabel value={"Never"} /> }
							</td>
						</tr>
						<tr>
							<td>
								<TextLabel value={"LastLogin"} />
							</td>
							<td>
								{ u.lastLogin ? new Date(u.lastLogin).toLocaleString(this.state.ll) : <TextLabel value={"Never"} />}
							</td>
						</tr>
						{ u.notes && (
							<tr>
								<td colSpan={2}>
									{ u.notes }
								</td>
							</tr>
						)}
						</tbody>
					</table>
				</ModalBody>
				<ModalFooter>
					<ButtonGroup
						className={"btn-icon"}
					>
						{ this.props.edit && (
							<Button
								color={"primary"}
								onClick={this.props.edit}
							>
								<i>
									<EditIcon />
								</i>
								<b>
									<TextLabel value={"Notes"} />
								</b>
							</Button>
						)}
					</ButtonGroup>
					<Button
						className={"btn-icon"}
						onClick={this.close}
					>
						<b>
							<TextLabel value={"Close"} />
						</b>
						<i>
							<CloseIcon />
						</i>
					</Button>
				</ModalFooter>
			</Modal>
		)
	}
}

export default UserInfoModal;
